import { CommonTranslations } from "./common/commonTranslations";
import { enCommonTranslations } from "./common/enCommonTranslations";
import { ruCommonTranslations } from "./common/ruCommonTranslations";
import { enScheduleBacnetTranslations } from "./scheduleBacnet/enScheduleBacnetTranslations";
import { ruScheduleBacnetTranslations } from "./scheduleBacnet/ruScheduleBacnetTranslations";
import { ScheduleBacnetTranslations } from "./scheduleBacnet/scheduleBacnetTranslations";

export type Translations = CommonTranslations & {
  scheduleBacnet: ScheduleBacnetTranslations;
}

const ruTranslations: Translations = {
  ...ruCommonTranslations,
  scheduleBacnet: ruScheduleBacnetTranslations,
}

const enTranslations: Translations = {
  ...enCommonTranslations,
  scheduleBacnet: enScheduleBacnetTranslations,
}

export const translations = {
  en: {
    translation: enTranslations,
  },
  ru: {
    translation: ruTranslations,
  }
}